import React from 'react';
import { Errors } from 'react-redux-form';

import './styles.css';

// Pass rowLabelComp to display a horizontally aligned
//  label to the left of the input field with error text
//  that spans the width of the label and the input field.
//  Without a rowLabelComp, only the input field and error
//  component are rendered.
const InputField = ({
  fieldProps,
  children,
}) => {
  const {
    model,
    RRFComp,
    control,
    error,
    rowLabelComp,
  } = fieldProps;
  return (
    <div styleName="inputGroup">
      <div styleName="labeledRow">
        {rowLabelComp}
        <RRFComp
          styleName={rowLabelComp ? 'fullBorderText' : 'text'}
          model={model}
          {...control}
          id={model}
        >
          {children}
        </RRFComp>
      </div>
      <Errors
        styleName="errorText"
        show={(error && error.show) || (field => field.touched || field.submitted)}
        model={model}
        {...error}
      />
    </div>
  );
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/Field.js